import { createContext, useContext } from 'react';

/**
 * Pathname de la navegación que React todavía no confirmó (el chunk de la ruta
 * destino sigue bajando), o `null` si no hay ninguna. Lo publica
 * `TransitionBrowserRouter`; fuera de él (stories, tests) siempre es `null`.
 */
export const PendingNavigationContext = createContext<string | null>(null);

export const usePendingPathname = (): string | null => useContext(PendingNavigationContext);
